import React from 'react';
import loginStyles from '../../../stylesheets/components/login.module.scss';
import {
  PreloadedQuery,
  graphql,
  usePreloadedQuery,
  useQueryLoader,
} from 'react-relay';
import { useLoaderData } from 'react-router-dom';
import type {
  LoginHeaderQuery as LoginHeaderQueryType,
  LoginHeaderQuery$data as LoginHeaderQueryResponse,
} from './__generated__/LoginHeaderQuery.graphql';
import LoginPMLogo from './LoginPMLogo';

export const LoginHeaderQuery = graphql`
  query LoginHeaderQuery($subdomain: String!) {
    publicLicense(subdomain: $subdomain) {
      name
      logoPath
    }
    publicBuilding(subdomain: $subdomain) {
      name
    }
  }
`;

const LoginHeader = () => {
  const loaderQueryReference = useLoaderData() as PreloadedQuery<
    LoginHeaderQueryType,
    LoginHeaderQueryResponse
  >;
  const [queryReference] = useQueryLoader<LoginHeaderQueryType>(
    LoginHeaderQuery,
    loaderQueryReference
  );

  const data = usePreloadedQuery(
    LoginHeaderQuery,
    queryReference as PreloadedQuery<LoginHeaderQueryType, LoginHeaderQueryType>
  );

  let headerTitle = '';
  let subHeaderTitle = '';
  if (data.publicBuilding?.name) {
    headerTitle = data.publicBuilding.name;
    if (data.publicLicense?.name) subHeaderTitle = data.publicLicense.name;
  } else if (data.publicLicense?.name) {
    headerTitle = data.publicLicense.name;
  }

  const hasPublicLicense = !!data.publicLicense;

  return (
    <div className={loginStyles.loginHeader}>
      {hasPublicLicense && data.publicLicense.logoPath ? (
        <img
          src={data.publicLicense.logoPath}
          className={loginStyles.loginBrandImage}
          alt=""
        />
      ) : (
        <div className={loginStyles.loginHeaderLogo}>
          <LoginPMLogo />
        </div>
      )}
      {headerTitle && (
        <span className={loginStyles.loginBusinessTitle}>{headerTitle}</span>
      )}
      {subHeaderTitle && (
        <span className={loginStyles.loginBusinessSubtitle}>
          {subHeaderTitle}
        </span>
      )}
    </div>
  );
};

export default LoginHeader;
